import styled from 'styled-components';
import { CardSection } from '../../../../CardInputs/CardsStyledComponents';
import { TextBold } from '../../../../../styles/GlobalStyledComponents';


export const AmountInputWrapper = styled.span`
  position: relative;
  display: flex;
  width: 100%;
`;

export const CardAmountSection = styled(CardSection)`
  position: relative;
  align-items: baseline;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.gray12};
  border-radius: 0 0 16px 16px;

  @media (max-width: 650px) {
    padding: 15px;
  }
`;

export const IconEuro = styled.span`
  position: absolute;
  left: 156px;
  top: 16px;
  width: 16px;
  height: 16px;
  background-image: url('./EurosIcon.svg');
  background-repeat: no-repeat;

  @media (max-width: 650px) {
    right: 16px;
    left: unset;
  }
`;

export const TextError = styled(TextBold)`
  color: ${(props) => props.theme.colors.red4};

  @media (max-width: 500px) {
    max-width: 280px;
  }

  @media (max-width: 320px) {
    margin-left: 0px;
  }
`;
export const TextAmountInput = styled.input`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 180px;
  height: 48px;
  padding: 12px;
  resize: none;
  margin-right: 25px;
  font-size: 16px;
  line-height: 22px;
  border-radius: 4px;
  border: solid 1px ${(props) => props.theme.colors.gray9};
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus-visible {
    outline: 1px solid ${(props) => props.theme.colors.gray9};
  }

  @media (max-width: 650px) {
    max-width: 100%;
    margin-right: 0px;
  }
`;
